var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conent",on:{"click":_vm.goHome}},[_c('div',{class:_vm.tranState ? 'conenttop' : ''})])
}
var staticRenderFns = []

export { render, staticRenderFns }